import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export interface User {
  id: number;
  name: string;
  email: string;
  isActive: boolean;
}

export type UserSession =
  | {
      user: User;
      accessToken: string;
    }
  | null
  | undefined;

const baseAuthStorageAtom = atomWithStorage<UserSession>('userSession', undefined, undefined, { getOnInit: true });
const authAtom = atom(
  get => get(baseAuthStorageAtom),
  (_get, set, update: UserSession | ((prev: UserSession) => UserSession)) => {
    const nextValue =
      typeof update === 'function' ? (update as (p: UserSession) => UserSession)(_get(baseAuthStorageAtom)) : update;
    set(baseAuthStorageAtom, nextValue);
  }
);

export const isAuthInitializedAtom = atom(get => get(baseAuthStorageAtom) !== undefined);

export default authAtom;
